import React, { useEffect, useState } from "react";

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  Switch,
} from "@mui/material";
import axios from "axios";
import toast from "react-hot-toast";
import { useDispatch, useSelector } from "react-redux";
import MUIDataTable from "mui-datatables";
import AddIcon from "@mui/icons-material/Add";
import Loader from "../../components/loader/Loader";
import { useForm } from "react-hook-form";
import EditIcon from "@mui/icons-material/Edit";
import { yupResolver } from "@hookform/resolvers/yup";
import { grey } from "@mui/material/colors";
import SaveIcon from "@mui/icons-material/Save";
import { categoryDiscountSchema } from "../../app/schema";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import { FormInputDropdown } from "../../components/form-components/FormInputDropdown";
import {
  hideConfirmModal,
  showConfirmModal,
  showModal,
} from "../../redux/counterSlice";
import { FormAutoComplete } from "../../components/form-components/FormAutoComplete";
import { parseArray } from "../../app/utlils";
import { usePermission } from "../../hooks/usePermission";

function CategoryDiscount() {
  const dispatch = useDispatch();
  const { categoryList } = useSelector((state) => state.counter);
  const permissions = usePermission("category Discount");
  const methods = useForm({
    resolver: yupResolver(categoryDiscountSchema),
  });
  const {
    handleSubmit,
    control,
    reset,
    formState: { errors },
  } = methods;

  const [loader, setLoader] = useState(true);
  const [formData, setFormData] = useState([]);
  const [discountList, setDiscountList] = useState([]);
  const [open, setOpen] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);

  const loadInitialData = async () => {
    try {
      setLoader(true);
      const [allDiscountCategoryList, allActiveDiscountList] = await axios.all([
        axios.get("/getAllDiscountCategoryList"),
        axios.get("/getAllActiveDiscountList"),
      ]);
      allDiscountCategoryList?.data?.data?.length > 0 &&
        setFormData(allDiscountCategoryList?.data?.data);
      allActiveDiscountList?.data?.data?.length > 0 &&
        setDiscountList(allActiveDiscountList?.data?.data);
    } catch (err) {
      toast.error(err?.message);
    } finally {
      setLoader(false);
      dispatch(hideConfirmModal({ msg: "" }));
    }
  };

  useEffect(() => {
    loadInitialData();
  }, []);

  const columns = [
    {
      name: "id",
      label: "S. No",
      options: {
        customBodyRenderLite: (dataIndex) => {
          return <p>{+dataIndex + 1}</p>;
        },
      },
    },
    {
      name: "discount_name",
      label: "Category Discount Name",
      options: {
        customBodyRenderLite: (dataIndex) => {
          return <p>{formData[dataIndex]?.discount?.[0]?.discount_name}</p>;
        },
      },
    },

    {
      name: "discount_percentage",
      label: "Percentage",
      options: {
        customBodyRenderLite: (dataIndex) => {
          return (
            <p>{formData[dataIndex]?.discount?.[0]?.discount_percentage}%</p>
          );
        },
      },
    },
    {
      name: "categories",
      label: "Categories",
      options: {
        customBodyRenderLite: (dataIndex) => {
          const categories = formData[dataIndex]?.category || [];
          const maxPills = 4;
          const allNames = categories.map((c) => c.itemName).join(", ");
          const pills = categories.slice(0, maxPills).map((category, idx) => (
            <span
              key={category.id || category.itemName || idx}
              title={allNames}
              style={{
                display: "inline-block",
                background: "#e0e7ff",
                color: "#3730a3",
                borderRadius: "16px",
                padding: "2px 10px",
                marginRight: "4px",
                fontSize: "12px",
                fontWeight: 500,
              }}
            >
              {category.itemName}
            </span>
          ));
          const extraCount = categories.length - maxPills;
          return (
            <span>
              {pills}
              {extraCount > 0 && (
                <span
                  style={{
                    display: "inline-block",
                    background: "#fca5a5",
                    color: "#991b1b",
                    borderRadius: "16px",
                    padding: "2px 10px",
                    fontSize: "12px",
                    fontWeight: 500,
                    cursor: "pointer",
                  }}
                  title={allNames}
                >
                  +{extraCount} more
                </span>
              )}
            </span>
          );
        },
      },
    },
    {
      name: "active_status",
      label: "Status",
      options: {
        customBodyRenderLite: (dataIndex) => {
          const status = formData[dataIndex]?.active_status;
          return (
            <Switch
              size="small"
              color={status === 1 ? "success" : "error"}
              checked={status === 1 ? true : false}
              onChange={() => {
                dispatch(
                  showConfirmModal({
                    msg: status === 1 ? "Deactivate" : "Activate",
                    action: () =>
                      toggleStatus(
                        formData[dataIndex]?.category_discount_id,
                        formData[dataIndex]?.active_status
                      ),
                  })
                );
              }}
              style={{ marginBottom: "5px" }}
            />
          );
        },
      },
    },
    ...(permissions?.edit
      ? [
          {
            name: "Edit",
            options: {
              customBodyRenderLite: (dataIndex) => {
                const status = formData[dataIndex]?.active_status;

                return (
                  <div className="actionBtns">
                    <Button
                      disabled={status === 1 ? true : false}
                      aria-label="edit"
                      onClick={() => editClickHandler(formData[dataIndex])}
                    >
                      <EditIcon
                        fontSize="medium"
                        sx={{ color: status === 1 ? grey[600] : "secondary" }}
                      />
                    </Button>
                  </div>
                );
              },
            },
          },
        ]
      : []),
    ...(permissions?.delete
      ? [
          {
            name: "Delete",
            options: {
              customBodyRenderLite: (dataIndex) => {
                const status = formData[dataIndex]?.active_status;

                return (
                  <div className="actionBtns">
                    <Button
                      disabled={status === 1 ? true : false}
                      aria-label="edit"
                      onClick={() => {
                        dispatch(
                          showConfirmModal({
                            msg: "Delete",
                            action: () =>
                              deleteClickHandler(
                                formData[dataIndex]?.category_discount_id
                              ),
                          })
                        );
                      }}
                    >
                      <DeleteOutlineOutlinedIcon
                        color="error"
                        fontSize="medium"
                        sx={{ color: status === 1 ? grey[600] : "red" }}
                      />
                    </Button>
                  </div>
                );
              },
            },
          },
        ]
      : []),
  ];
  const handleClose = () => {
    setOpen(false);
    setSelectedRow(null);
    reset();
  };
  const editClickHandler = (item) => {
    setOpen(true);
    setSelectedRow({ ...item });
  };
  const onSubmit = (data) => {
    saveForm(data);
  };

  const toggleStatus = (id, status) => {
    setLoader(true);
    const toggleDiscountApi =
      status == 0
        ? "/activateDiscountCategory/"
        : "/deActivateDiscountCategory/";
    axios
      .get(toggleDiscountApi + id)
      .then(function () {
        loadInitialData();
      })
      .catch(function (err) {
        toast.error(err?.message);
      })
      .finally(() => {
        setLoader(false);
      });
  };
  const saveForm = async (data) => {
    setLoader(true);
    try {
      let response;
      const payload = {
        category: parseArray(data?.category)?.toString(),
        discount_id: data?.discount_id,
      };

      if (selectedRow?.category_discount_id) {
        response = await axios.post("/updateDiscountCategory", {
          category_discount_id: selectedRow?.category_discount_id,
          ...payload,
        });
      } else {
        response = await axios.post("/createDiscountCategory", payload);
      }

      if (!response?.data?.error) {
        toast.success(response?.data?.message);
        loadInitialData();
        setOpen(false);
        setSelectedRow(() => null);
        reset();
      } else {
        let errDesc = "";
        if (response?.data?.data) {
          Object.values(response?.data?.data).map((error, index) => {
            errDesc =
              index === 0 ? errDesc + error + "\n " : errDesc + error + "\n ";
          });
        } else {
          errDesc = response?.data?.message;
        }

        dispatch(
          showModal({
            msg: errDesc,
            error: response?.data?.error,
          })
        );
        setOpen(false);
      }
    } catch (error) {
      dispatch(
        showModal({
          msg: error?.message,
          error: true,
        })
      );
      setOpen(false);
    } finally {
      setLoader(false);
    }
  };
  const deleteClickHandler = async (id) => {
    setLoader(true);
    try {
      let response;
      if (id) {
        response = await axios.get("/deleteDiscountCategory/" + id);
        if (!response?.data?.error) {
          toast.success(response?.data?.message);
          loadInitialData();
          setOpen(false);
          setSelectedRow(() => null);
          reset();
        } else {
          let errDesc = "";
          if (response?.data?.data) {
            Object.values(response?.data?.data).map((error, index) => {
              errDesc =
                index === 0 ? errDesc + error + "\n " : errDesc + error + "\n ";
            });
          } else {
            errDesc = response?.data?.message;
          }

          dispatch(
            showModal({
              msg: errDesc,
              error: response?.data?.error,
            })
          );
        }
      }
    } catch (error) {
      dispatch(
        showModal({
          msg: error?.message,
          error: true,
        })
      );
    } finally {
      setLoader(false);
      setOpen(false);
    }
  };
  const CreateEditDialog = React.memo(() => {
    return (
      <Dialog open={open} onClose={handleClose} maxWidth={"sm"} fullWidth>
        <DialogTitle className="text-primary">
          {selectedRow ? "Edit Category Discount" : "New Category Discount"}
        </DialogTitle>
        <DialogContent>
          <Grid container columnSpacing={{ xs: 5 }}>
            <Grid item xs={12}>
              <FormAutoComplete
                name="category"
                control={control}
                label="Category"
                multiple={true}
                dataArray={categoryList?.map((item) => ({
                  value: item?.id,
                  label: item?.category_name,
                }))}
                errors={errors}
                defaultValue={selectedRow?.category?.map((item) => ({
                  value: item?.id,
                  label: item?.itemName,
                }))}
                mandatory="true"
              />
            </Grid>
            <Grid item xs={12}>
              <FormInputDropdown
                name="discount_id"
                control={control}
                label="Discount"
                type="single"
                options={discountList?.map((item) => ({
                  id: item?.discount_id,
                  name: `${item?.discount_name} (${item?.discount_percentage}%)`,
                }))}
                errors={errors}
                defaultValue={selectedRow?.discount_id}
                mandatory="true"
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} variant="contained" color="error">
            Cancel
          </Button>
          <Button
            // disabled={!isValid}
            color="primary"
            variant="contained"
            onClick={handleSubmit(onSubmit)}
            startIcon={<SaveIcon />}
          >
            Save
          </Button>
        </DialogActions>
      </Dialog>
    );
  });

  const options = {
    selectableRows: false,
    filter: false,
    download: true,
    viewColumns: true,
    print: false,
  };
  return (
    <>
      {loader ? (
        <Loader />
      ) : (
        <>
          <h4 className="text-dark">Category Discount</h4>
          <MUIDataTable
            data={formData?.length > 0 ? formData : []}
            columns={columns}
            options={options}
            title={
              permissions.add ? (
                <Button
                  size="small"
                  variant="contained"
                  onClick={() => {
                    setSelectedRow(null);
                    setOpen(true);
                    reset();
                  }}
                  icon={<AddIcon />}
                >
                  New Category Discount
                </Button>
              ) : null
            }
          />
        </>
      )}
      <CreateEditDialog />
    </>
  );
}

export default CategoryDiscount;
